/* global axios */
import ApiClient from './ApiClient';

class AccountScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get({ conversationDisplayId, status } = {}) {
    return axios.get(this.url, {
      params: {
        ...(conversationDisplayId
          ? { conversation_display_id: conversationDisplayId }
          : {}),
        ...(status ? { status } : {}),
      },
    });
  }

  getCount({ status = 'pending', conversationId } = {}) {
    return axios.get(`${this.url}/count`, {
      params: {
        status,
        ...(conversationId ? { conversation_id: conversationId } : {}),
      },
    });
  }
}

export default new AccountScheduledMessagesAPI();
